import React from "react";
import { Link, LinkProps } from "react-router-dom";

const AdapterLink = React.forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => (
    <Link ref={ ref as any } { ...props } />
));

export default AdapterLink;